/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FieldArray } from 'redux-form/immutable';
import store from '../../../../redux/store';

import FiltersComponent from '../components/FiltersComponent';
import { PriorityField } from '../components/Fields/PriorityField';
import { InputField, DetailHeader, SelectField, SidePanelActions } from 'cx-ui-components';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 30px;
`;
const Header = styled.h3`
  font-size: 28px;
  color: #474747;
  font-weight: 700;
`;
const QueryHeaderWrapper = styled.div`
  display: flex;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 10px;
`;
const StyledDetailHeader = styled(DetailHeader)`
  flex-grow: 1;
  color: #656565 !important;
  margin: 0px !important;
`;
const SwitchQueryTypeLink = styled.span`
  display: inline-block;
  font-size: 14px;
  color: #3498db;
  cursor: pointer;
  :hover {
    color: #07487a;
  }
`;
const QueueSlaErrorMsg = styled.span`
  font-size: 14px;
  color: red;
  margin-left: 160px;
`;
const StyledSidePanelActions = styled(SidePanelActions)`
  padding-top: 10px;
  padding-bottom: 20px;
`;
const PriorityFieldWrapper = styled.div``;

const SlaFieldWrapper = styled.div``;

class QueueQueryLayoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQueryType: null,
    };
  }
  switchQueryType = (queryType) => {
    this.setState({ showQueryType: queryType });
  };
  render() {
    return (
      <form onSubmit={this.props.handleSubmit} key={this.props.key}>
        <HeaderContainer>
          <Header>{`Creating New Queue Version: v${this.props.versionsCountInSelectedQueue + 1}`}</Header>
        </HeaderContainer>

        <QueryHeaderWrapper>
          <StyledDetailHeader text="Query" />
          {(!this.state.showQueryType || this.state.showQueryType === 'basic') && (
            <SwitchQueryTypeLink
              onClick={() => {
                this.switchQueryType('advanced');
                this.props.convertQueueQueryObjToEdn(this.props.basicQuery);
              }}>
              (Show advanced query)
            </SwitchQueryTypeLink>
          )}
          {this.state.showQueryType === 'advanced' && (
            <SwitchQueryTypeLink
              onClick={() => {
                this.switchQueryType('basic');
                store.dispatch({ type: 'CONVERT_EDN_STRING_TO_IMMUTABLE' });
              }}>
              (Show basic query)
            </SwitchQueryTypeLink>
          )}
        </QueryHeaderWrapper>

        {this.state.showQueryType === 'advanced' ? (
          <InputField
            name="query"
            label="Query"
            inputType="text"
            componentType="textarea"
            data-automation="advacnedQueryInput"
            disabled={this.props.isSaving || !this.props.userHasUpdatePermission}
          />
        ) : (
          <FieldArray
            name="basicQuery"
            rerenderOnEveryChange
            component={FiltersComponent}
            props={{
              dependentEntities: this.props.dependentEntities,
              disabled: this.props.isSaving,
              basicQuery: this.props.basicQuery,
              change: this.props.change,
              userHasUpdatePermission: this.props.userHasUpdatePermission,
              querylevelCountInSelectedVersion: this.props.querylevelCountInSelectedVersion,
              matchmaker2Enabled: this.props.matchmaker2Enabled,
            }}
          />
        )}

        <PriorityFieldWrapper>
          <DetailHeader text="Priority" />
          <PriorityField disabled={this.props.isSaving || !this.props.userHasUpdatePermission} />
        </PriorityFieldWrapper>

        <SlaFieldWrapper>
          <DetailHeader text="Service Level Agreement" />
          <SelectField
            name="slaId"
            label="Queue SLA"
            options={this.props.tenantSlas}
            data-automation="queueSlaList"
            disabled={this.props.isSaving || !this.props.userHasUpdatePermission}
          />
          <QueueSlaErrorMsg>
            Interactions already completed or in queue won't be impacted by this change.
          </QueueSlaErrorMsg>
        </SlaFieldWrapper>

        <StyledSidePanelActions
          onCancel={() => this.props.setSelectedSubEntityId(undefined)}
          isSaving={this.props.isSaving}
          invalid={this.props.invalid}
        />
      </form>
    );
  }
}

QueueQueryLayoutForm.propTypes = {
  basicQuery: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  change: PropTypes.func,
  convertQueueQueryObjToEdn: PropTypes.func,
  dependentEntities: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  invalid: PropTypes.bool,
  isSaving: PropTypes.bool,
  key: PropTypes.string,
  matchmaker2Enabled: PropTypes.bool,
  querylevelCountInSelectedVersion: PropTypes.number,
  selectedQueueName: PropTypes.string,
  selectedSubEntityId: PropTypes.string,
  setSelectedSubEntityId: PropTypes.func,
  tenantSlas: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  userHasUpdatePermission: PropTypes.bool,
  versionsCountInSelectedQueue: PropTypes.number,
};

export default QueueQueryLayoutForm;
